import React from "react";
import { Link } from "react-router-dom";
import { getMenuIcon } from "@/utils/menu";

export function buildMenuItems(menus = [], level = 1) {
  return menus.map((menu) => {
    const { code, iconKey, name, path, subMenus } = menu;
    const Icon = getMenuIcon(iconKey, code);
    const item = {
      key: code,
      className: `menu-${level}`,
      label: subMenus ? name : <Link to={`/page${path}`}>{name}</Link>,
      ...(level === 1 && Icon ? { icon: Icon } : {}),
    };

    if (subMenus) {
      item.children = buildMenuItems(subMenus, level + 1);
    }
    return item;
  });
}
